import dateTimeFromUnix from "@/core/helpers/dateTimeFromUnix";
import { unixFromDateTime } from "@/core/helpers/unixFromDateTime";

export function dateFormat(date: string | Date, isTime: boolean = false) {
  if (!date) return "";

  const dateUnix = unixFromDateTime(date);
  const dateObj = dateTimeFromUnix(dateUnix, "Europe/Moscow");
  const time = isTime ? `${dateObj.hours}:${dateObj.minutes}` : "";

  return `${dateObj.day}.${dateObj.month}.${dateObj.year} ${time}`;
}
